<ngx-loading-bar ref="router" [includeSpinner]="false"></ngx-loading-bar>
<router-outlet></router-outlet>	